import { render, staticRenderFns } from "./KeywordHeader.vue?vue&type=template&id=3230eb3d"
import script from "./KeywordHeader.vue?vue&type=script&lang=js"
export * from "./KeywordHeader.vue?vue&type=script&lang=js"
import style0 from "./KeywordHeader.vue?vue&type=style&index=0&id=3230eb3d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports